import {Blue3, Green4, Grey17, Grey6} from "../../theme/styles";

import {EnlilTable} from "../EnlilTable";
import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import {Chip, IconButton, Menu, MenuItem, Tooltip, Typography} from "@mui/material";
import css_buttons from "../../components/Common/css/CCButton.module.scss";
import css_self from "../Navigation/css/NavBar.module.scss";
import ProjectPlanFormApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanFormApplet";
import EventBus from "../../util/EventBus";
import {hasPrivilege} from "../../util/SessionContext";
import {ControlPoint, DeleteForever, Info, MoreVert, Refresh} from "@mui/icons-material";
import React from "react";

class ProjectPlanTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("project-plan-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("project-plan-form-applet-save", this.onCancelHandler);
    };

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("project-plan-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("project-plan-form-applet-save", this.onCancelHandler);
    };

    enterpriseComponentUpdateCompleted(ec) {
        super.enterpriseComponentInsertCompleted(ec)

        ec.invalidateChildren();
    }

    onRowClick = (params, e, details) => {
        const navigate = this.props.navigate;
        navigate("/project-plan/project-plan-detail", {
            state: {
                projectPlanUSID: this.state.buffer[params.row.id].get("USID")
            },
        });
        super.onRowClick(params);
    };

    getCellRenderer(name) {
        if (name === "Status Cell") {
            return this.renderStatusCell;
        } else if (name === "Action Cell") {
            return this.renderActionCell;
        }
        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "New Project Plan") {
            this.setState({renderTarget: "New Project Plan"});
        }
        super.handleMenuClick(identifier);
    }

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderExtension() {
        if (this.state.renderTarget === "New Project Plan") {
            return <ProjectPlanFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="New"/>;
        } else if (this.state.renderTarget === "Delete Plan") {
            return <ProjectPlanFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Delete"/>;
        }
    };

    renderMenuContent() {
        let menuItems = [];

        menuItems.push(
            <MenuItem key={"menuItem1"} onClick={(e) => {
                if (hasPrivilege("ADD_PLAN")) {
                    e.stopPropagation();
                    this.handleMenuClick("New Project Plan");
                    this.setState({showMenu: false});
                } else {
                    // do nothing
                }
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <ControlPoint sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                New Project Plan
                {!hasPrivilege("ADD_PLAN") ? (
                    <div style={{marginLeft: "10px", marginTop: "6px"}}>
                        <Tooltip title={"This feature is disabled because you do not have the 'ADD_PLAN' privilege in any of your assigned roles."}>
                            <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                        </Tooltip>
                    </div>
                ) : null}
            </MenuItem>
        );
        menuItems.push(
            <MenuItem key={"menuItem2"} onClick={(e) => {
                e.stopPropagation();
                this.handleMenuClick("Refresh");
                this.setState({showMenu: false});
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <Refresh sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                Refresh
            </MenuItem>
        );

        return menuItems;
    };

    renderStatusCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let status;
        let backgroundColor;
        let content = [];

        if (Array.isArray(this.state.buffer[params.row.id].get("Status"))) {
            let a = this.state.buffer[params.row.id].get("Status")
            if (a.find((element) => element === "Draft") !== undefined || (a.find((element) => element === "DRAFT") !== undefined)) {
                status = "DRAFT";
                backgroundColor = Blue3;
                content.push(<Chip id="1" label={status} size="small" style={{marginRight: "5px", fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: 1}}/>)
            }
            if (a.find((element) => element === "Approved") !== undefined || (a.find((element) => element === "APPROVED") !== undefined)) {
                status = "RELEASED";
                backgroundColor = Green4;
                content.push(<Chip id="2" label={status} size="small" style={{marginRight: "5px", fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: 1}}/>)
            }
        } else {
            if (this.state.buffer[params.row.id].get("Status") === "DRAFT" || this.state.buffer[params.row.id].get("Status") === "Draft") {
                status = "DRAFT";
                backgroundColor = Blue3;
                content.push(<Chip id="1" label={status} size="small" style={{fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: 1}}/>)
            } else if (this.state.buffer[params.row.id].get("Status") === "RELEASED") {
                status = "RELEASED";
                backgroundColor = Green4
                content.push(<Chip id="2" label={status} size="small" style={{fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: 1}}/>)
            } else {
                status = "--";
                content = <Typography style={{marginTop: "10px"}}>{status}</Typography>
            }
        }
        return (
            <div style={{marginTop: "-2px"}}>
                {content}
            </div>
        );
    };

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-10px"}}>
                <IconButton className={css_buttons.tableOptionButton} onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"2"} className={css_self.Standard} onClick={() => {
                        if (hasPrivilege("DELETE_PLAN") && this.applet.getEnterpriseComponent().getAttributeValue("NumberOfDonePhases") === 0) {
                            this.setState({tableActionMenuTarget: null, renderTarget: "Delete Plan"});
                        }
                    }}>
                        <DeleteForever style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Delete Plan</Typography>
                        {!hasPrivilege("DELETE_PLAN") || this.applet.getEnterpriseComponent().getAttributeValue("NumberOfDonePhases") > 0 ? (
                            <div style={{marginTop: "6px"}}>
                                <Tooltip title={this.applet.getEnterpriseComponent().getAttributeValue("NumberOfDonePhases") > 0 ? "This project cannot be deleted because it has at least one phase that is 'DONE'" : "This project cannot be deleted because you do not have the 'Delete Plan' privilege."}>
                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                </Tooltip>
                            </div>
                        ) : null}
                    </MenuItem>
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(ProjectPlanTable)));